import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { get } from 'lodash';
import { IExistingReorderRequest, IRequestsReorderDetailEdit } from './_types';
import { getRequest } from '../_api';
import { IStudy } from 'modules/Studies/StudyDetail/_types';
import { useEntityInfo } from 'utils/hooks/useEntityInfo';
import { useAppGlobals } from 'utils/hooks/useAppGlobals';
import { StudiesReorderDetail } from 'modules/Studies/StudiesReorder/StudiesReorderDetail';

const RequestsReorderDetailEdit: React.FC<IRequestsReorderDetailEdit> = () => {
  const { id } = useEntityInfo();
  const { toggleLoader } = useAppGlobals();
  const navigate = useNavigate();

  const [request, fetchRequest] = useState<IExistingReorderRequest>();
  const [sourceStudy, fetchSourceStudy] = useState<IStudy[]>();
  const [targetStudy, fetchTargetStudy] = useState<IStudy[]>();

  const loadEntity = async () => {
    if (id) {
      toggleLoader();
      const request = (await getRequest(parseInt(id.toString(), 10))) as
        | IExistingReorderRequest
        | false;
      if (request) {
        fetchRequest(request);
        fetchSourceStudy(get(request, 'data.source'));
        fetchTargetStudy(get(request, 'data.target'));
      } else {
        navigate('/requests');
      }
      toggleLoader(false);
    }
  };

  useEffect(() => {
    loadEntity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {request ? (
        <StudiesReorderDetail
          isRequest={true}
          isRequestEdit={true}
          requestSourceStudy={sourceStudy}
          requestTargetStudy={targetStudy}
          request={request}
        />
      ) : null}
    </>
  );
};

export default RequestsReorderDetailEdit;
